import type { JSX } from 'react'
import type { Padding } from './Controls.h'

import React from 'react'
import {
  AlignItems,
  Direction,
  Fluid,
  JustifyContent,
  Paddings,
} from './Controls.h'
import { WrapperControls } from './Controls.styled'

export interface IControlsProps {
  children: React.ReactNode
  direction?: Direction
  justifyContent?: JustifyContent
  alignItems?: AlignItems
  fluid?: Fluid
  paddings?: Padding
  controlsState?: {
    visible: boolean
    disabled: boolean
    handleClick?: () => void
  }[]
}

export const ContainerControls = ({
  children,
  direction = Direction.Row,
  justifyContent = JustifyContent.FlexStart,
  alignItems = AlignItems.FlexStart,
  fluid = Fluid.None,
  paddings = Paddings.SIZE_0,
  controlsState,
}: IControlsProps): JSX.Element => (
  <WrapperControls
    direction={direction}
    justifyContent={justifyContent}
    alignItems={alignItems}
    fluid={fluid}
    controlsState={controlsState}
    paddings={paddings}
  >
    {React.Children.count(children)
      ? controlsState?.map((item, i) =>
          React.cloneElement(children?.[i], { key: i, ...item })
        )
      : null}
  </WrapperControls>
)
